import type { CSSProperties } from 'react';

/* Skeleton framework-agnostic (blocks não tem Tailwind). Cores neutras via
   inline style; usado enquanto a coleção/canal ainda carrega no builder. */
const block = (style: CSSProperties): CSSProperties => ({
  background: 'color-mix(in srgb, var(--lpfs-text-body, #186643) 10%, transparent)',
  borderRadius: 8,
  ...style,
});

export const SimuladorFinanciamentoSkeleton = () => (
  <div data-testid="simulador-financiamento-skeleton" className="lpfs-container" aria-hidden>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, opacity: 0.7 }}>
      <div style={block({ height: 40, width: '100%' })} />
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 360px', gap: 24 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={block({ height: 16, width: 160 })} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div style={block({ height: 160 })} />
            <div style={block({ height: 160 })} />
          </div>
          <div style={block({ height: 96 })} />
        </div>
        <div style={block({ height: 288 })} />
      </div>
    </div>
  </div>
);
